import React from 'react';

const ExcellenceSection: React.FC = () => {
  return (
    <section className="bg-appbg px-6 py-12 lg:px-20">
      <div className="mx-auto max-w-[1728px]">
        <div className="rounded-[20px] border border-line bg-card p-6 sm:p-8 lg:p-10">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div className="max-w-[760px]">
              <h2 className="text-[36px] font-extrabold leading-[1.1] tracking-[-0.03em] text-primary-800 sm:text-[32px] lg:text-[40px]">
                Architected for Business Excellence
              </h2>
              <p className="mt-5 max-w-[880px] text-[20px] leading-[1.5] sm:text-[16px]">
                Gain unprecedented control and real-time visibility into your company&apos;s spend<br /> without
                adding friction to the workflow.
              </p>
            </div>
            <span className="rounded-full bg-primary-50 px-5 py-2 text-[12px] font-bold tracking-[0.15em] text-primary-700">
              FINANCE TEAMS
            </span>
          </div>

          <div className="mt-8 grid gap-4 lg:grid-cols-[2fr_1fr]">
            <article className="relative overflow-hidden rounded-[22px] border border-primary-100 bg-primary-50 px-6 py-8">
              <span className="text-primary-800">
                <svg viewBox="0 0 24 24" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 19V9" />
                  <path d="M10 19V6" />
                  <path d="M16 19v-4" />
                  <path d="M3 19h18" />
                  <path d="m4 12 5-4 4 3 7-7" />
                </svg>
              </span>
              <h3 className="mt-5 text-[24px] font-bold tracking-[-0.02em] text-primary-800 lg:text-[40px]">
                Real-time Expense Tracking
              </h3>
              <p className="mt-3 max-w-[620px] text-[12px] leading-[1.5] text-ink/80 lg:text-[16px]">
                Watch every transaction as it happens. Our live dashboard delivers real-time insights, so you never have to wait for month-end to understand your burn rate.
              </p>
            </article>

            <article className="rounded-[22px] bg-primary-800 px-6 py-8 text-white">
              <span className="text-primary-100">
                <svg viewBox="0 0 24 24" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 3 5.5 5.8v6c0 4.3 2.8 7.6 6.5 9.2 3.7-1.6 6.5-4.9 6.5-9.2v-6L12 3Z" />
                  <circle cx="12" cy="12" r="2.2" />
                </svg>
              </span>
              <h3 className="mt-5 text-[24px] font-bold tracking-[-0.02em] text-white lg:text-[40px]">
                Policy Controls
              </h3>
              <p className="mt-3 text-[14px] leading-[1.5] text-primary-100 lg:text-[16px]">
                Automate your travel policy at the point of purchase. Set limits by department, seniority,
                or project, blocking non-compliant spend before it occurs.
              </p>
              <div className="mt-6 border-t border-primary-600 pt-5">
                <p className="text-[14px] font-semibold">
                  <span className="mr-2 text-primary-200">●</span>
                  98% Compliance Rate
                </p>
              </div>
            </article>
          </div>

          <div className="mt-4 grid gap-4 lg:grid-cols-[1fr_2fr]">
            <article className="rounded-[22px] border border-primary-100 bg-primary-50 px-6 py-7">
              <span className="text-primary-800">
                <svg viewBox="0 0 24 24" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="6" width="18" height="14" rx="2" />
                  <path d="M7 12h6" />
                  <path d="M7 16h3" />
                </svg>
              </span>
              <h3 className="mt-4 text-[24px] font-bold tracking-[-0.02em] text-primary-800 lg:text-[40px]">
                Automated Reconciliation
              </h3>
              <p className="mt-3 text-[14px] leading-[1.5] text-ink/80 lg:text-[16px]">
                Say goodbye to spreadsheets. Every payment instantly converts into a verified expense—no manual entry, no matching, no errors.
              </p>
            </article>

            <article className="rounded-[22px] border border-primary-100 bg-primary-50 px-6 py-7">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <span className="text-primary-800">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-9 w-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
                    </svg>
                  </span>
                  <h3 className="mt-4 text-[24px] font-bold tracking-[-0.02em] text-primary-800 lg:text-[40px]">
                    UPI-Based Payment Infrastructure
                  </h3>
                  <p className="mt-3 max-w-[720px] text-[14px] leading-[1.5] text-ink/80 lg:text-[16px]">
                    Enable employees to pay directly via UPI with built-in controls—no corporate cards, no out-of-pocket spend, fully compliant by design.
                  </p>
                </div>
                {/* <div className="flex gap-2">
                  <span className="flex h-12 w-12 items-center justify-center rounded-[12px] bg-card text-primary-700">
                    <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M8 9a4 4 0 0 1 0 6" />
                      <path d="M5 7a7 7 0 0 1 0 10" />
                      <path d="M12 8v8" />
                    </svg>
                  </span>
                  <span className="flex h-12 w-12 items-center justify-center rounded-[12px] bg-card text-primary-700">
                    <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="8" />
                      <path d="M4 12h16" />
                      <path d="M12 4a12 12 0 0 0 0 16" />
                    </svg>
                  </span>
                </div> */}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExcellenceSection;
